import palette from "layouts/ThemeProvider/palette";

const DEFAULT_INVITE_THEME = {
  id: "",
  name: "Default Theme",
  titleFont: "Inter",
  titleFontColor: palette.text.main,
  hostLabelFont: "Inter",
  hostLabelFontColor: palette.primary.main,
  hostFont: "Inter",
  hostFontColor: palette.text.main,
  descriptionFont: "Inter",
  descriptionFontColor: palette.text.main,
  locationLabelFont: "Inter",
  locationLabelFontColor: palette.primary.main,
  locationFont: "Inter",
  locationFontColor: palette.text.main,
  dateLabelFont: "Inter",
  dateLabelFontColor: palette.primary.main,
  dateFont: "Inter",
  dateFontColor: palette.text.main,
  guestListFont: "Inter",
  guestListFontColor: palette.text.main,
  invitationBackgroundColor: "",
  guestListBackgroundColor: palette.wildSand,
  eventDetailsBackgroundColor: palette.porcelain,
  invitationBorderColor: "",
};

Object.freeze(DEFAULT_INVITE_THEME);

export { DEFAULT_INVITE_THEME };
